@if (show || locked) {
  <div [@fadeInOut]="true">
    <ng-content></ng-content>
    @if (!isSoftDeleted && showEdit) {
      <button mat-icon-button (click)="editItem()">
        <mat-icon [svgIcon]="editOff ? 'edit:edit_off' : 'edit:edit'" [matTooltip]="editTooltip"  matTooltipPosition="above"></mat-icon>
      </button>
    }
    @if (isSoftDeleted) {
      <button mat-icon-button (click)="restoreItem()">
        <mat-icon svgIcon="edit:restore_from_trash_black" i18n-matTooltip matTooltip="Restore item"  matTooltipPosition="above"></mat-icon>
      </button>
    }
    @if (!isSoftDeleted && showDelete) {
      <button  mat-icon-button [disabled]="disableDelete" (click)="softDeleteItem()">
        <mat-icon svgIcon="edit:delete" [matTooltip]="deleteTooltip"  matTooltipPosition="above"></mat-icon>
      </button>
    }
    @if (isSoftDeleted) {
      <button mat-icon-button (click)="hardDeleteItem()" color="warn">
        <mat-icon class="hard-delete" svgIcon="edit:delete" i18n-matTooltip matTooltip="Remove item permanently" matTooltipPosition="above"></mat-icon>
      </button>
    }
  </div>
}


